
import './Ad_login.scss';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import fnc from '../../mymod/commFunction';
import { useSelector, useDispatch } from 'react-redux';
import { setIsAdmin, setIsLoggedIn, setUserName } from '../../reduxToolkit/reduxIgong';
import Ad_page_main from '../page_menu/Ad_menu';

function Ad_login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userId, setUserId] = useState('admin');
  const [password, setPassword] = useState('1234');

  const handleSubmit = (event) => {
    event.preventDefault(); // 폼 전송에 의한 페이지 새로고침 방지
    fncAd_login(userId, password);
  };

function fncAd_login(basicid, pw) {
 
    dispatch(setIsLoggedIn(true));
    dispatch(setIsAdmin(true));
    dispatch(setUserName('관리자'));
    navigate('/Ad_menu'); 

//   fnc.sendAxios('/basicLogin', { basicid, pw }, (res) => {
//     if (res) {
//       const cnt =res.result[0].cnt;
//       if(!cnt) {
//         alert('정보가 일치하지 않습니다.');
//         return;
//       }

//       if(basicid === 'admin' && res.token) {
//         fnc.setCookie('token', res.token, 1);
//         dispatch(setIsAdmin(true));
//         dispatch(setIsLoggedIn(true));
//         navigate('/'); 
//       }else{
//         fnc.setCookie_pure('token','',1);
//       }     


//     } else {
//       console.log("joinRoutes/속성이 obj 내에 없습니다.");
//     }
//   });
}

function onUpdatePw() {
  navigate("/updatepw");
}

  //===============================================
  return (
    <div className='Ad_login'>
  
    <form onSubmit={handleSubmit}>
      <p className='title'>관리자 로그인</p>
      <div>
        <label htmlFor="userId">*아이디</label>
        <input
          type="text"
          id="userId"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
      </div>
      <div>
        <label htmlFor="password">*비밀번호</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <Button variant='contained' className='btnLogin' type='submit' >로그인</Button>
      {/* <Button className='btnUpdatePw' onClick={onUpdatePw}>비밀번호 수정</Button> */}
    </form>
          
    </div>
  );
}

export default Ad_login;
